import {
  SET_AUTH_DATA_SAGA,
} from "../../helpers/constants";

export type SetAuthDataSaga = {
  type: typeof SET_AUTH_DATA_SAGA,
  companies: string[],
  history: any,
  redirect: string,
  expires: Date,
}

export type Actions = SetAuthDataSaga

export const setAuthDataSaga = ({
  companies,
  history,
  redirect,
  expires,
}: {
  companies: string[];
  history: any;
  redirect: string;
  expires: Date;
}): SetAuthDataSaga => ({
  type: SET_AUTH_DATA_SAGA,
  companies,
  history,
  redirect,
  expires,
});
